"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VerifyingIcon_1 = __importDefault(require("./VerifyingIcon"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default(VerifyingIcon_1.default) `
    position: absolute;
    left: -2.5em;
    transform: scale(0.5);
`;
//# sourceMappingURL=VerifyingIconStyled.js.map